import { HeadingComponentContent } from '../../../types/elearning';

interface HeadingBlockViewerProps {
  content: HeadingComponentContent;
}

const headingClasses: Record<1 | 2 | 3 | 4 | 5 | 6, string> = {
  1: 'text-4xl font-bold text-gray-900 mb-4',
  2: 'text-3xl font-bold text-gray-900 mb-3',
  3: 'text-2xl font-semibold text-gray-900 mb-3',
  4: 'text-xl font-semibold text-gray-900 mb-2',
  5: 'text-lg font-semibold text-gray-900 mb-2',
  6: 'text-base font-semibold text-gray-900 mb-2',
};

const headingTags = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
} as const;

export default function HeadingBlockViewer({ content }: HeadingBlockViewerProps) {
  const HeadingTag = headingTags[content.level];
  const className = headingClasses[content.level];

  return <HeadingTag className={className}>{content.text}</HeadingTag>;
}

